import * as React from 'react';
import type { JsonObject } from '@/app-package';
import { AppointmentDoc } from '@bb/domain/dist/schemas';
import { formatTimeStr, getInternalShowingDetailsUrl } from 'utils';

type UpcomingAppointmentDetailProps = {
  appointment: JsonObject<AppointmentDoc>;
};

const UpcomingAppointmentDetail = ({
  appointment,
}: UpcomingAppointmentDetailProps) => {
  const timeStartString = formatTimeStr(
    appointment.time,
    appointment.listing.timezone,
  );
  const timeEndString = formatTimeStr(
    appointment.timeEnd,
    appointment.listing.timezone,
  );
  const timeText = `${timeStartString} - ${timeEndString}`;

  const listingAddress = `${appointment.listing.line1}${
    appointment.listing.line2 ? `, ${appointment.listing.line2}` : ''
  }`;

  return (
    <div className="row appointment-detail">
      <div className="col-lg-3 appointment-detail__time-container">
        {appointment.status === 'confirm' ? (
          <i className="fa fa-circle appointment-detail__indicator"></i>
        ) : (
          <i className="fa fa-circle-o appointment-detail__indicator"></i>
        )}
        {timeText}
      </div>
      <div className="col-lg-4">{listingAddress}</div>
      <div className="col-lg-3">
        {appointment.status === 'confirm' && !appointment.isPending ? (
          <span style={{ color: 'green' }}>Confirmed</span>
        ) : (
          <span>Request Pending</span>
        )}
      </div>
      <div className="col-lg-2">
        <a
          href={getInternalShowingDetailsUrl(appointment.id)}
          className="btn btn-xs btn-info"
          data-cy={`manage-${appointment.id}`}
        >
          Manage
        </a>
      </div>
    </div>
  );
};

export default UpcomingAppointmentDetail;
